import React from 'react';

export const Hospital = ({ size = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M17.625 6.27273H15V5.04545C15 3.918 14.1593 3 13.125 3H10.875C9.84075 3 9 3.918 9 5.04545V6.27273H6.375C4.51425 6.27273 3 7.92464 3 9.95455V17.3182C3 19.3481 4.51425 21 6.375 21H17.625C19.4858 21 21 19.3481 21 17.3182V9.95455C21 7.92464 19.4858 6.27273 17.625 6.27273ZM9.75 5.04545C9.75 4.36882 10.2548 3.81818 10.875 3.81818H13.125C13.7452 3.81818 14.25 4.36882 14.25 5.04545V6.27273H9.75V5.04545ZM20.25 17.3182C20.25 18.8973 19.0725 20.1818 17.625 20.1818H6.375C4.9275 20.1818 3.75 18.8973 3.75 17.3182V9.95455C3.75 8.37545 4.9275 7.09091 6.375 7.09091H17.625C19.0725 7.09091 20.25 8.37545 20.25 9.95455V17.3182Z"
      fill="#636363"
      stroke="#636363"
    />
    <path
      d="M14.625 14.0455C14.832 14.0455 15 13.8622 15 13.6364C15 13.4106 14.832 13.2273 14.625 13.2273H12.375V10.7727C12.375 10.5469 12.207 10.3636 12 10.3636C11.793 10.3636 11.625 10.5469 11.625 10.7727V13.2273H9.375C9.168 13.2273 9 13.4106 9 13.6364C9 13.8622 9.168 14.0455 9.375 14.0455H11.625V16.5C11.625 16.7258 11.793 16.9091 12 16.9091C12.207 16.9091 12.375 16.7258 12.375 16.5V14.0455H14.625Z"
      fill="#007E47"
      stroke="#007E47"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/Hospital.icon.jsx